export const LENS_MODEL_OPTIONS = Object.freeze([
  { key: 'sonnet', title: 'Sonnet 4.5', subtitle: 'Best answers' },
  { key: 'haiku', title: 'Haiku 4.5', subtitle: 'Fastest' },
  { key: 'sonnet46', title: 'Sonnet 4.6', subtitle: 'Newer reasoning' },
  { key: 'nova2lite', title: 'Nova 2 Lite', subtitle: 'Fast multimodal' },
]);
